import { useStore, useStoreMap } from 'effector-react'
import { rentalContractModel } from '~/entities/RentalContract'
import { CarAccessControlEnum } from '~/shared/config/enums'
import { Button } from '~/shared/ui/Buttons'
import { LockIcon, UnlockIcon } from '~/shared/ui/icons'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { $isCarAccessControlLoading, carAccessControl } from './model'
import { Wrapper } from './styled'

export function CarAccessControl() {
  const isLoading = useStore($isCarAccessControlLoading)

  const isSupportOpenCloseDoors = useStoreMap(
    rentalContractModel.$rentalContract,
    (rentalContract) => rentalContract?.getCar()?.getIsSupportOpenCloseDoors(),
  )

  if (!isSupportOpenCloseDoors) return null

  return (
    <Wrapper>
      {isLoading && (
        <Skeleton
          animated
          $height={44}
          style={{
            margin: '0',
            '--background': 'rgba(255, 255, 255, 0.8)',
            '--background-rgb': '255, 255, 255',
          }}
        />
      )}
      {!isLoading && (
        <>
          <Button
            variant='whiteFlooded'
            onClick={() => carAccessControl(CarAccessControlEnum.LOCK)}
            startDecorator={<LockIcon />}
            fullWidth
          >
            Закрыть
          </Button>
          <Button
            onClick={() => carAccessControl(CarAccessControlEnum.UNLOCK)}
            startDecorator={<UnlockIcon />}
            fullWidth
          >
            Открыть
          </Button>
        </>
      )}
    </Wrapper>
  )
}
